import * as React from "react";
import { Link } from "react-router-dom";
import { AdminHeader } from "../admin-header";
import { useResources } from "contexts/resource-context";

const AdminDashboard = () => {
    const resource = useResources();

    return (
        <div className={"container mt-4"}>
            <AdminHeader title={"Admin"} />

            <div className={"mt-4 mb-4"}>
                <ul className={"list-inline list-unstyled"}>
                    <li>
                        <Link
                            to={"/admin/user/list"}
                            className={"mb-2"}
                            style={{
                                display: "inline-block",
                            }}>
                            {resource.Admin_Dashboard_Users}
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={"/admin/order/list"}
                            className={"mb-2"}
                            style={{
                                display: "inline-block",
                            }}>
                            {resource.Admin_Dashboard_Orders}
                        </Link>
                    </li>

                    <li>
                        <Link to={"/admin/theme/list"}>
                            {resource.Admin_Dashboard_Themes}
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default AdminDashboard;
